import {PERSON_ACTIVE_DATA_GET} from "../actions";

export default function(state = {}, action) {

  switch (action.type) {
    case PERSON_ACTIVE_DATA_GET:
      //console.log('rdcr_person_active -- PERSON_ACTIVE_DATA_GET -- action.payload', action.payload)
      return action.payload;
    default:
      return state;
  }
}
